import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { DownloadPresentationButtonComponent } from './core/components/header/components/download-presentation-button/download-presentation-button.component';
import { FilterButtonComponent } from './core/components/header/components/filter-button/filter-button.component';
import { EbrCoreModule } from './core/components/ebr-core.module';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { SmartpowerModule } from "./features/smartpower/smartpower.module";
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SharedModule } from './shared/shared.module';
import {
  MsalModule,
  MsalRedirectComponent
} from "@azure/msal-angular";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from "@angular/forms";
import { ServiceInsightsModule } from './features/service-insights/service-insights.module';
import { SPDModule } from './features/solution-participation-details/solution-participation-details.module';
import { FilterSelectionComponent } from './features/filter-selection/filter-selection.component';
import { MatSelectModule, MAT_SELECT_CONFIG } from '@angular/material/select';
import { GenericFilterPanelModule } from './features/generic-filter-panel/generic-filter-panel.module';
import { ActionCenterModule } from './features/action-center/action-center.module';
import { TotalValueDeliveryModule } from './features/total-value-delivery/total-value-delivery.module';
import { CustomerServiceInsightsModule } from './features/customer-service-insights/customer-service-insights.module';
import { ImpersonateOptionComponent } from './core/components/header/components/impersonate-option/impersonate-option.component';
import { ViewSelectionComponent } from './core/components/header/components/view-selection/view-selection.component';
import { WINDOW_PROVIDERS } from './core/services/window.service';
import { TelemetryModule } from './core/services/telemetry/telemetry.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ToastrModule } from 'ngx-toastr';
import { APP_INITIALIZER_PROVIDERS, HOST_CONFIG_PROVIDERS } from './config/AppInitializer.factory';
import { AUTHENTICATION_PROVIDERS, AUTHENTICATION_SETTINGS_PROVIDERS } from './config/MsalLoader.service';
import { GLOBAL_CACHE_PROVIDERS } from './config/GlobalCacheLoader.service';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        DownloadPresentationButtonComponent,
        FilterButtonComponent,
        FilterSelectionComponent,
        NavbarComponent,
        ImpersonateOptionComponent,
        ViewSelectionComponent
    ],
    imports: [
        EbrCoreModule,
        BrowserModule,
        AppRoutingModule,
        GenericFilterPanelModule,
        BrowserAnimationsModule,
        MatButtonModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: true, // Enable for all environments
            // Register immediately
            registrationStrategy: 'registerImmediately'
        }),
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        SmartpowerModule,
        MsalModule,
        FormsModule,
        ServiceInsightsModule,
        SPDModule,
        MatSelectModule,
        BaseChartDirective,
        ActionCenterModule,
        TotalValueDeliveryModule,
        CustomerServiceInsightsModule,
        SharedModule,
        TelemetryModule,
        NgIdleKeepaliveModule.forRoot(),
        ToastrModule.forRoot()
    ],
    providers: [
        provideCharts(withDefaultRegisterables()),
        APP_INITIALIZER_PROVIDERS,
        Title,
        WINDOW_PROVIDERS,
        HOST_CONFIG_PROVIDERS,
        AUTHENTICATION_SETTINGS_PROVIDERS,
        AUTHENTICATION_PROVIDERS,
        GLOBAL_CACHE_PROVIDERS,
        {
            // Angular Material MDC migration: global mat-select defaults to bridge legacy behavior.
            // panelWidth 'auto' — MDC sizes the panel to the trigger; legacy sized it to content.
            // hideSingleSelectionIndicator — removes MDC's new checkmark/pseudo-checkbox on the
            // selected single-select option, which legacy never showed.
            provide: MAT_SELECT_CONFIG,
            useValue: {
                panelWidth: 'auto',
                hideSingleSelectionIndicator: true
            }
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
